(function () {
  var host = document.querySelector('[data-bb-active]');
  if (!host || window.avviBuybox) return;
  var fallback = host.dataset.bbActive;
  var groups = [fallback];
  var templates = {};
  templates[fallback] = host.cloneNode(true);
  document.querySelectorAll('template[data-bb-template]').forEach(function (template) {
    groups.push(template.dataset.bbTemplate);
    templates[template.dataset.bbTemplate] = template.content;
  });
  function rendered(variant) { return Object.prototype.hasOwnProperty.call(templates, variant); }
  var params = new URLSearchParams(window.location.search);
  var forced = params.get('bb');
  var preview = rendered(forced);
  var interacted = false;
  host.addEventListener('change', function () { interacted = true; });
  host.addEventListener('submit', function () { interacted = true; }, true);
  host.addEventListener('click', function (event) {
    if (event.target.closest('.lp-plan, [data-lp-submit]')) interacted = true;
  });
  function select(variant) {
    if (!rendered(variant) || interacted) return false;
    if (preview && variant !== forced) return false;
    if (host.dataset.bbActive === variant) return true;
    host.querySelectorAll('dialog[open]').forEach(function (dialog) { dialog.close(); });
    if (!host.hasAttribute('data-bb-preserve-media')) document.dispatchEvent(new Event('lp:unmount'));
    var content = templates[variant].cloneNode(true);
    host.replaceChildren.apply(host, Array.from(content.childNodes));
    host.dataset.bbActive = variant;
    document.dispatchEvent(new Event('lp:mount'));
    document.dispatchEvent(new Event('avvi:buybox:change'));
    return true;
  }
  window.avviBuybox = { select: select, current: function () { return host.dataset.bbActive; } };
  function applyAssignment() {
    var assigned = window.avviBuyboxVariant;
    select(preview ? forced : (rendered(assigned) ? assigned : fallback));
  }
  document.addEventListener('avvi:buybox', applyAssignment);
  applyAssignment();
  if (host.dataset.bbActive === fallback) document.dispatchEvent(new Event('avvi:buybox:change'));
  if (preview) {
    var bar = document.querySelector('[data-bb-preview]');
    if (bar) {
      bar.hidden = false;
      bar.className = 'lp-bb-preview';
      var title = document.createElement('strong');
      title.textContent = 'Buybox preview · ' + forced.toUpperCase();
      bar.appendChild(title);
      groups.forEach(function (key) {
        var link = document.createElement('a');
        var url = new URL(window.location.href);
        url.searchParams.set('bb', key);
        var theme = window.Shopify && window.Shopify.theme;
        if (theme && (theme.role === 'development' || theme.role === 'unpublished')) url.searchParams.set('preview_theme_id', theme.id);
        link.href = url.href;
        link.textContent = key.toUpperCase() + (key === fallback ? ' · default' : '');
        if (key === forced) link.setAttribute('aria-current', 'page');
        bar.appendChild(link);
      });
    }
  }
})();
